import script from "./CtaBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CtaBlock.vue?vue&type=script&setup=true&lang=js"

import "./CtaBlock.vue?vue&type=style&index=0&id=3ce82f58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce82f58"]])

export default __exports__